angular.module('shared').factory('EmploymentService', function() {
  var EmploymentService, employment, getEmployment, parseEmployment;
  employment = void 0;
  getEmployment = function() {
    var attrs, data, el, ref;
    el = $('#current-employment');
    if (!(el.html() || ((ref = window.DATA) != null ? ref.permissions : void 0))) {
      window.location.href = '/';
      return {
        permissions: {}
      };
    }
    attrs = el.html() ? (data = $.parseJSON(el.html()), el.remove(), data) : {
      permissions: [].concat(window.DATA.permissions)
    };
    employment = parseEmployment(attrs);
    return employment;
  };
  parseEmployment = function(employment) {
    var permissions;
    permissions = employment.permissions;
    employment.permissions = _.object(permissions, _.range(permissions.length).map(function() {
      return true;
    }));
    return employment;
  };
  EmploymentService = {
    get: function() {
      return employment || getEmployment();
    }
  };
  return EmploymentService;
});
